import React, { useState, useEffect } from 'react'
import GroupMixrPill from 'srcReact/components/common2/GroupMixrPill'
import styles from './styles.module.scss'
import { formatLastUpdateDate, getDateFormat2, getTimeFormat2 } from 'srcReact/helpers/datetimeHelper'
import Actions from './Actions'
import { useTranslation } from 'react-i18next'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { useDispatch, useSelector } from 'react-redux'
import { mixrActions } from 'srcReact/Mixr/actions'
import Spinner from 'srcReact/components/common2/Spinner'
import Icon from 'srcReact/components/icons/Icon'
import { chunkArrayInGroups } from 'srcReact/helpers/utils'
import { decode } from 'html-entities'

function MixrList({ search, currentOrgId, groupId, searchGroupId, handleUseMixrOrDraft, handlePreviewMixrOrDraft }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    common: { isNative, isMobile },
    login: { user: loggedUser },
    mixr: {
      existingMixrs: { list, stats, loading }
    }
  } = useSelector((state) => state)

  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const [showAccordion, setShowAccordion] = useState(false)
  const [recurrenceMixrId, setRecurrenceMixrId] = useState('')

  const lastMixrRef = useInfinitScroll(loading, stats && stats.remaining, stats && stats.next_offset, setPagination, [
    loading
  ])

  useEffect(() => {
    dispatch(mixrActions.getExistingMixrList(currentOrgId, groupId, searchGroupId, search, pagination))
  }, [])

  useEffect(() => {
    if (pagination.isPagination) {
      dispatch(mixrActions.getExistingMixrList(currentOrgId, groupId, searchGroupId, search, pagination))
    }
  }, [pagination])

  const handleShowRecurrentMixrs = (mixr) => {
    setRecurrenceMixrId(mixr.mixr_id)
    setShowAccordion(recurrenceMixrId === mixr.mixr_id ? !showAccordion : true)
  }

  return (
    <div className={styles.list}>
      {list && list.length > 0 ? (
        list.map((mixr, index) => {
          const isLast = list.length === index + 1
          return mixr.recurrent_events === null ? (
            <div className={styles.item} ref={isLast ? lastMixrRef : null}>
              <button onClick={() => handleUseMixrOrDraft(mixr.mixr_id)} className={styles.info}>
                <React.Fragment>
                  <GroupMixrPill size='medium' type='mixr' picture={mixr.picture.url} />
                  <div className={`${styles.data} ${styles.mixrData}`}>
                    <span
                      className={styles.datetime}
                      dangerouslySetInnerHTML={{
                        __html: `<span>${formatLastUpdateDate(
                          mixr.event_utc_start_datetime,
                          getDateFormat2()
                        )}</span> ${t('global.at')} ${formatLastUpdateDate(
                          mixr.event_utc_start_datetime,
                          getTimeFormat2()
                        ).toLowerCase()}`
                      }}
                    />

                    <h1 className={styles.name}>{mixr.mixr_name}</h1>
                  </div>
                </React.Fragment>
              </button>
              <Actions
                id={mixr.mixr_id}
                scope='mixr'
                handlePreviewMixrOrDraft={handlePreviewMixrOrDraft}
                handleUseMixrOrDraft={handleUseMixrOrDraft}
              />
            </div>
          ) : (
            <div
              className={`${styles.accordionWrapper} ${
                showAccordion && mixr.mixr_id === recurrenceMixrId && styles.openedAccordion
              }`}
              key={mixr.mixr_id}
              role='button'
              ref={isLast ? lastMixrRef : null}>
              <div className={styles.item} onClick={() => handleShowRecurrentMixrs(mixr)}>
                <div className={styles.info}>
                  <GroupMixrPill size='medium' type='mixr' picture={mixr.picture.url} />
                  <div className={`${styles.data} ${styles.mixrData}`}>
                    <span
                      className={styles.datetime}
                      dangerouslySetInnerHTML={{
                        __html: `<span>${formatLastUpdateDate(
                          mixr.event_utc_start_datetime,
                          getDateFormat2()
                        )}</span> ${t('global.at')} ${formatLastUpdateDate(
                          mixr.event_utc_start_datetime,
                          getTimeFormat2()
                        ).toLowerCase()}`
                      }}
                    />

                    <h1 className={styles.name}>{mixr.mixr_name}</h1>
                  </div>
                </div>
                {showAccordion && mixr.mixr_id === recurrenceMixrId ? (
                  <Icon name='chevron-up24' size='large32' styleModifier={styles.accordionIcon} />
                ) : (
                  <Icon name='chevron-down24' size='large32' styleModifier={styles.accordionIcon} />
                )}
              </div>

              <div className={styles.recurrenceContentWrapper}>
                {mixr.mixr_id === recurrenceMixrId &&
                  showAccordion &&
                  mixr.recurrent_events?.length >= 1 &&
                  chunkArrayInGroups(
                    mixr.recurrent_events,
                    mixr.recurrent_events.length / (mixr.recurrent_events.length < 3 || isMobile ? 1 : 2)
                  ).map((arr, index) => (
                    <div className={`${styles.recurrenceContentColumn} `} key={index}>
                      {arr.map((rec, idx) => (
                        <div className={styles.recurrenceContent} key={idx}>
                          <button
                            className={styles.recurrenceContentInfo}
                            onClick={() => handleUseMixrOrDraft(rec.event_id)}
                            key={rec.event_id}>
                            {rec?.picture?.url ? (
                              <img src={rec.picture.url} alt={decode(rec.name)} className={styles.picture} />
                            ) : (
                              <img
                                src={require('srcReact/assets/images/background-default-mixr.jpg')}
                                alt='default'
                                className={styles.picture}
                              />
                            )}
                            <div className={styles.datetime}>
                              {formatLastUpdateDate(
                                `${rec.event_start_date} ${rec.event_start_time}`,
                                getDateFormat2()
                              )}
                            </div>
                          </button>
                          <Actions
                            id={rec.event_id}
                            scope='mixr'
                            handlePreviewMixrOrDraft={handlePreviewMixrOrDraft}
                            handleUseMixrOrDraft={handleUseMixrOrDraft}
                          />
                        </div>
                      ))}
                    </div>
                  ))}
              </div>
            </div>
          )
        })
      ) : loading && !pagination.isPagination ? (
        <Spinner />
      ) : (
        <div
          className={styles.notFound}
          dangerouslySetInnerHTML={{
            __html: search
              ? t('event.create.startFrom.noMixrFoundSearch', { mixrName: search })
              : t('event.create.startFrom.noMixrFound')
          }}
        />
      )}
      {loading && pagination.isPagination && <Spinner />}
    </div>
  )
}

export default MixrList
